import * as Yup from "yup";

const NewPasswordValidationScheme = Yup.object().shape({
  newPassword: Yup.string().required(),
});

export default NewPasswordValidationScheme;
